import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import Badge from 'base-ui/dist/Badge';
import Icon from 'base-ui/dist/Icon';
import CoursesLink from 'components/CoursesLink';
import messages from './messages';

function BuyButton({ price, campaignItem, slug, source, campaign, medium, buttonText, courseName }) {
  const articleUrl = ['courseUrl', slug, 'payment'];

  let priceNew = price.eur;
  if (campaignItem) {
    priceNew = parseFloat(
      price.eur - (price.eur * campaignItem.discount) / 100
    ).toFixed(2);
  }

  const badgeStyle = {
    fontWeight: 400,
    backgroundColor: '#2cb3aa',
    borderColor: '#2cb3aa'
  };

  switch (buttonText) {
    case 'quote': {
      return (
        <CoursesLink
          toRoute={articleUrl}
          source={source}
          campaign={campaign}
          medium={medium}
          courseName={courseName}
        >
          <Badge
            textColor="white"
            className="btn full main-bg main-border secondary-font white-color"
            style={badgeStyle}
          >
            <FormattedMessage {...messages.moreInformation} />
          </Badge>
        </CoursesLink>
      );
    }
    case 'price':
    default: {
      return (
        <CoursesLink
          toRoute={articleUrl}
          source={source}
          campaign={campaign}
          medium={medium}
          courseName={courseName}
        >
          <Badge
            textColor="white"
            className="btn full main-bg main-border secondary-font white-color"
            style={badgeStyle}
          >
            <Icon prefix="fas" name="shopping-cart" />
            {' '}
            {/* eslint-disable-next-line react/style-prop-object */}
            <FormattedNumber value={priceNew} currency="EUR" style="currency" minimumFractionDigits={2} />
          </Badge>
        </CoursesLink>
      );
    }
  }
}

export default BuyButton;
